<template>
	<div class="lottery">
		<header>
			<div class="g-header">
				<div class="left"></div>
				<div class="middle fs-18">{{ $t('jiaoyidating') }}</div>
				<div class="right">
					<div class="bg-icon bg-icon-setting"></div>
				</div>
			</div>
			<div class="blockHeight"></div>
		</header>
		<div class="g-content mescroll">
			<view class="tab-box">
				<button v-for="(item, index) in gameList" :key="index"
					:class="['tab','cu-btn', 'margin-tb-sm', 'round', curr === index + 1 ? 'bg-gradual-black-blue' : 'line-gold']"
					@click="curr = index + 1">
					<text>{{ item.name }}</text>
				</button>
			</view>
			<div v-for="(item, index) in filteredGameList" :key="index" class="game-group">
				<ul class="level-box">
					<template v-for="(liitem, Liindex) in item.planList" :key="Liindex">
						<li class="level"
							@click="changeroom(liitem.id, liitem.game_id, liitem.robot_num, liitem.join_limit)">
							<div class="title">
								<div class="level-name">{{ getLevelName(liitem.type) }}</div>
							</div>
							<div class="text-box">
								<div class="text1">
									<span>{{ $t('zuiditouzi') }}</span>
									<span class="price">{{ liitem.min_limit }}</span>
								</div>
								<div class="text2">
									<span>{{ $t('zuidijinru') }}</span>
									<span class="price">{{ liitem.join_limit }}</span>
								</div>
								<div class="people-box">
									<img src="@/assets/trade/icon_people.png" class="icon" alt="" />
									<span>{{ liitem.robot_num }}</span>
								</div>
							</div>
						</li>
					</template>
				</ul>
			</div>
		</div>
		<tab-bar></tab-bar>
	</div>
</template>
<script>
	import TabBar from "@/components/tabbar/TabBar.vue";
	import homeApi from "@/api/home";
	export default {
		name: "Lottery",
		components: {
			TabBar,
		},
		data() {
			return {
				curr: 1,
				gameList: [],
				robotNumOrigin: {},
			};
		},
		computed: {
			money() {
				console.log(this.$store.state.money);
				return this.$store.state.money;
			},
			filteredGameList() {
				return this.gameList.filter((item, index) => this.curr === index + 1)
			}
		},
		methods: {
			getLevelName(type) {
				let names = [
					this.$t('jichu'),
					this.$t('putong'),
					this.$t('zhuanye'),
					this.$t('guibin'),
					this.$t('chaoguibin'),
				]
				return names[type] || ''
			},
			handleClickSlide(index) {
				console.log(index);
			},
			tabIndex(target, nodeList) {
				for (let i = 0; i < nodeList.length; i++) {
					if (target === nodeList[i]) {
						return i;
					}
				}
			},
			changeroom(id, game_id, robot_num, joinmoeny) {
				// 判断进入金额和自己的金额
				console.log(this.money * 1, joinmoeny * 1, robot_num)
				if (this.money * 1 < joinmoeny * 1) {
					// alert(1)
					this.$toast(this.$t('Tips.zcbz'))
					return
				}
				this.$router.push({
					path: "/betRoom",
					query: {
						id: id,
						game_id: game_id,
						onlineNum: robot_num,
					},
				});
			},
			info() {},
			getFluctuatedValue(baseValue) {
				const fluctuation = baseValue * 0.1;
				const randomOffset = (Math.random() * 2 - 1) * fluctuation;
				return Math.round(baseValue + randomOffset);
			},
			startRobotNumFluctuation() {
				setInterval(() => {
					this.gameList.forEach(item => {
						item.planList.forEach(liitem => {
							if (!this.robotNumOrigin[liitem.id]) {
								this.robotNumOrigin[liitem.id] = liitem.robot_num;
							}
							liitem.robot_num = this.getFluctuatedValue(this.robotNumOrigin[liitem
								.id]);
						});
					});
				}, 3000);
			},
		},
		mounted() {
			this.$toast.loading({
				message: this.$t('jiazaizhong'),
				forbidClick: true,
				duration: 0,
			});
			homeApi
				.Lotteryinfo("", "")
				.then((data) => {
					console.log(data.data);
					this.gameList = data.data.gameList;
					this.startRobotNumFluctuation();
					this.$toast.clear();
				})
				.catch((err) => {
					this.$toast.clear();
					this.$toast.fail(err.msg);
				});
		},
		created() {},
	};
</script>

<style lang="less" scoped>
	.lottery {
		height: 100%;
		display: flex;
		padding-bottom: 50px;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		background-color: #333;
		color: #fff;
	}

	.mescroll {
		-webkit-box-flex: 1;
		-ms-flex: 1;
		flex: 1;
		overflow-y: auto;
	}

	.tab-box {
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		// margin: 0.36rem 0 0.54rem;
		// border: 1px solid #4bb3e8;
		// border-radius: 4px;
		position: relative;
		padding: 15px;
	}

	.round {
		border-radius: 2500px;
	}

	.cu-btn {
		border: 0px;
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 0 15px;
		font-size: 14px;
		height: 32px;
		line-height: 1;
		text-align: center;
		text-decoration: none;
		overflow: visible;
		margin-left: 0;
		-webkit-transform: translate(0px, 0px);
		transform: translate(0px, 0px);
		margin-right: 0;
	}

	.cu-btn[class*="line"]::after {
		content: " ";
		display: block;
		width: 200%;
		height: 200%;
		position: absolute;
		top: 0;
		left: 0;
		border: 1px solid currentColor;
		-webkit-transform: scale(.5);
		transform: scale(.5);
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		box-sizing: border-box;
		border-radius: 6px;
		z-index: 1;
		pointer-events: none;
		border-radius: 500px;
	}

	.tab {
		font-size: 16px;
		font-weight: bolder;
		width: 30%;
		margin-left: 2%;
	}

	.margin-tb-sm {
		margin-top: 10px;
		margin-bottom: 10px;
	}

	.line-gold {
		color: #b8a78a;
	}

	.bg-gradual-black-blue {
		background-image: linear-gradient(45deg, #0d99e6, #191a1a);
		color: #fff;
	}

	.swiper-container {
		// height: 300px;
		width: 100%;

		.swiper-wrapper {
			.swiper-slide {}
		}
	}

	.level-box {}

	.level {
		// height: 3rem;
		// margin-bottom: 0.2rem;
		background-repeat: no-repeat;
		// background-size: 100% 100%;
		background-image: url(../assets/trade/item_bg.png);
		text-align: left;
		background-size: cover;
		border-radius: 5px;
		min-height: 100px;
		background-position: 50%;
		margin-top: 20px;
	}

	.level-box li:first-child {
		margin-top: 0;
	}

	.title {
		// display: flex;
		// -webkit-box-align: center;
		// -ms-flex-align: center;
		// align-items: center;
		// padding: 0.5rem 0.56rem 0;
		// font-size: 0.45rem;
		color: rgb(243, 215, 166);
		margin-left: 3%;
		line-height: 60px;
		font-size: 20px;
		font-weight: bolder;
	}

	.level-name {
		width: 2.5rem;
	}

	.people-box {
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		// margin-left: 0.2rem;
		// font-size: 0.45rem;

		.icon {
			// margin-right: 0.06rem;
			// width: 0.5rem;
			// height: 0.5rem;
			width: 15px;
			height: 12px;
			margin-right: 8px;
		}
	}

	.text-box {
		// padding: 0.3rem 0.56rem 0;
		// font-size: 0.3rem;
		// text-align: left;
		display: flex;
		line-height: 30px;
		color: aliceblue;
		margin-left: 3%;
		font-size: 14px;
	}

	.text1 {
		// min-width: 2.1rem;
		width: 35%;
	}

	.text2 {
		width: 40%;
	}

	.price {
		padding-left: 0.1rem;
	}

	.text:last-child {
		margin-top: 0.2rem;
	}

	.game-group {
		padding: 15px;
	}
</style>